
export function RuntimeHttpEndpointURL() {

    switch (location.host) {

        case "affectation-front.stereodev.ca": //Environnement qa - Stereo
            return 'https://affectation.stereodev.ca/graphql';

        case "affectations-qa.stereodev.ca": //Environnement dev - Mecanitec
            return 'https://affectqaapi.stereodev.ca/graphql';

        case "mecanitec.monriff.ca":
        case "mecanitec.myriff.ca":
            return 'https://mecanitec.api.monriff.ca/graphql';

        case "demo.monriff.ca":
        case "demo.myriff.ca":
            return 'https://demo.api.monriff.ca/graphql';

        case "mecanitec-qa.monriff.ca":
            return 'https://mecanitec-qa.api.monriff.ca/graphql';

        case "metafab.monriff.ca":
            return 'https://metafab.api.monriff.ca/graphql';

        case "localhost:8081":
        default:
            return process.env.VUE_APP_GRAPHQL_HTTP || null

    }
}